import { Add, Delete, Edit } from "@material-ui/icons";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import {
  deleteSailorSpecialization,
  fetchSailorSpecialization,
} from "../../../services/sailorSpecializationService";

import CreateDialog from "./CreateDialog";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../components/Table";
import DeleteDialog from "../../components/CustomDeleteDialog";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import UpdateDialog from "./UpdateDialog";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useState } from "react";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

function SailorSpecialization() {
  const { t } = useLocale();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const { data, isError, isLoading, refetch } = useQuery(
    "sailorSpecialization",
    fetchSailorSpecialization
  );
  return (
    <>
      <Helmet title={t("Sailor Specializations")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Sailor Specializations")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Link component={NavLink} exact to="/#">
          {t("Parameters")}
        </Link>
        <Typography>{t("Sailor Specializations")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <CustomAlert
        open={isError}
        close={() => {
          refetch();
        }}
        message={t("A network error occured, please try again later")}
      />

      <CustomTable
        isLoading={isLoading}
        columns={[
          {
            title: t("Id"),
            field: "id",
            width: "80px",
          },
          {
            title: t("Name"),
            field: "name",
          },
        ]}
        data={data}
        actions={[
          {
            icon: () => <Add />,
            tooltip: t("Add"),
            isFreeAction: true,
            onClick: () => {
              setIsCreateDialogOpen(true);
            },
          },
          {
            icon: () => <Edit style={{ color: "#1E90FF" }} />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
          {
            icon: () => <Delete style={{ color: "#B22222" }} />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
        ]}
      />
      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refetch}
      />

      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
      />
      <DeleteDialog
        title={t("Delete Sailor Specialization")}
        message={t(
          "Are you sure you want to delete the selected Sailor Specialization"
        )}
        fieldName="name"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
        deleteService={deleteSailorSpecialization}
      />
    </>
  );
}

export default SailorSpecialization;
